import React from 'react';
import unique from 'lodash/array/unique';
import t from 'tcomb';
import Locale from './Locale';
import Shipping from './Shipping';
import Runtime from './Runtime';
import Sponsor from './Sponsor';
import Color from './Color';
import get_bundle from './get_bundle';
import Custom_Payment from './Custom_Payment';
import Payment_Type from './Payment_Type';
import UUID from './UUID';
import URL from './URL';
import Currency from './Currency';
import Amount from './Amount';
import Datetime from './Datetime';
import Natural from './Natural';
import Authorization from './Authorization';
import StdShipping from '../components/StdShipping';
import CouponShipping from '../components/CouponShipping';
import ProductShippings from '../components/ProductShippings';

const Product = t.struct({
  id: UUID,
  locale: Locale,
  name: t.Str,
  description: t.Str,  //ex markdown
  image: URL,
  currency: Currency,
  list_price: Amount,
  color: t.maybe(Color),
  end_date: Datetime,
  nr_items: Natural,
  max_items: Natural,
  min_price: Amount,
  details: t.Str,  //ex markdown
  shippings: t.list(Shipping),
  is_coupon: t.Bool,
  is_invoiced: t.Bool,
  is_min_price_hidden: t.Bool,
  payments: t.list(Payment_Type),
  custom_payments: t.maybe(t.list(Custom_Payment)),
  runtime: t.maybe(Runtime),
  privacy: t.maybe(t.Str),  // ex markdown
  sponsor: t.maybe(Sponsor),
  start_price: Amount,
  pending_purchase_message: t.maybe(t.Str),  //ex markdown
  gift_card_not_supported: t.maybe(t.Bool),
  bonus_not_supported: t.maybe(t.Bool),
  button_label: t.maybe(t.Str),
  authorization: t.maybe(Authorization),
  min_buy_price: t.maybe(Amount)
}, 'Product');

Product.of = (p) => {
  p.locale = Locale.of(p.locale);
  return new Product(p);
};

Product.prototype.shipping_countries = function() {
  return unique(this.shippings.map(function(shipping) {
    return shipping.country;
  }));
};

// Un prodotto è scaduto quando non è passata la sua end_date
Product.prototype.is_expired = function() {
  return new Date().getTime() > this.end_date;
};

// Un prodotto è disponibile se non è scaduto e
// se non sono stati venduti tutti gli item
Product.prototype.is_available = function() {
  return !this.runtime.is_sold_out && !this.is_expired();
};

// utility per formattare i prezzi del prodotto
Product.prototype.format_amount = function(locale, amount) {
  return Amount.format(locale, this.currency, amount);
};

Product.prototype.replace_runtime = function(runtime) {
  return Product.update(this, { runtime: { $set: runtime } });
};


Product.prototype.display_shippings = function(locale) {
  var product = this;
  if (this.is_coupon) {
    return (
      <CouponShipping
        locale={locale}
        currency={product.currency}
      />
    ); //product.display_shipping(locale, Coupon_Shipping.of_locale(locale), true);
  }
  else {
    return <ProductShippings locale={locale} product={product}/>; // this.get_html_shippings_groupped(locale);
  }
};

Product.prototype.display_shipping = function(locale, shipping, omit_country) {
  return (<StdShipping
    locale={locale}
    currency={this.currency}
    shipping={shipping}
    omit_country={omit_country} />
  );
};


Product.prototype.total = function(locale, order) {
  let total = this.runtime.price;
  const current_shipping = (order && order.domicile) ? order.domicile.shipping : null;
  if (current_shipping) {
    total += current_shipping.cost;
  }
  else if (!this.is_coupon && this.shippings.length === 1) {
    total += this.shippings[0].cost;
  }
  return this.format_amount(locale, total);
};

Product.prototype.getBuyButtonLabel = function(locale) {
  return this.button_label ?
    this.button_label :
    get_bundle(locale).product.console.go_buy[0];
};

Product.prototype.hasPrivacy = function () {
  return this.privacy !== null;
};

module.exports = Product;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Product.js
 **/